var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (ViewHelpers, pastFairs, undefined) {
// iterate pastFairs
;(function(){
  var $$obj = pastFairs;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var fair = $$obj[$index];

buf.push("<a" + (jade.attr("href", fair.href, true, true)) + " class=\"fairs__past-fair\"><div class=\"fairs__past-fair__cell fairs__past-fair__cell--icon\">");
if ( fair.profile.icon)
{
buf.push("<img" + (jade.attr("alt", fair.name, true, true)) + (jade.attr("title", fair.name, true, true)) + (jade.attr("src", fair.profile.icon.url, true, true)) + " class=\"large-profile-image\">");
}
buf.push("</div><div class=\"fairs__past-fair__cell fairs__past-fair__cell--name\"><div class=\"fairs-fair__name\">" + (jade.escape(null == (jade_interp = fair.name) ? "" : jade_interp)) + "</div><div class=\"fairs-fair__follow\"><div" + (jade.attr("data-id", fair.profile.id, true, true)) + " class=\"entity-follow profile-follow\"></div></div></div><div class=\"fairs__past-fair__cell fairs__past-fair__cell--info\"><div class=\"fairs-fair__info\">" + (jade.escape((jade_interp = ViewHelpers.formatDates(fair)) == null ? '' : jade_interp)) + "</div>");
if ( fair.location && (fair.location.city || fair.location.country))
{
buf.push("<div class=\"fairs-fair__info\">" + (jade.escape(null == (jade_interp = fair.location.city ? fair.location.city : fair.location.country) ? "" : jade_interp)) + "</div>");
}
buf.push("</div></a>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var fair = $$obj[$index];

buf.push("<a" + (jade.attr("href", fair.href, true, true)) + " class=\"fairs__past-fair\"><div class=\"fairs__past-fair__cell fairs__past-fair__cell--icon\">");
if ( fair.profile.icon)
{
buf.push("<img" + (jade.attr("alt", fair.name, true, true)) + (jade.attr("title", fair.name, true, true)) + (jade.attr("src", fair.profile.icon.url, true, true)) + " class=\"large-profile-image\">");
}
buf.push("</div><div class=\"fairs__past-fair__cell fairs__past-fair__cell--name\"><div class=\"fairs-fair__name\">" + (jade.escape(null == (jade_interp = fair.name) ? "" : jade_interp)) + "</div><div class=\"fairs-fair__follow\"><div" + (jade.attr("data-id", fair.profile.id, true, true)) + " class=\"entity-follow profile-follow\"></div></div></div><div class=\"fairs__past-fair__cell fairs__past-fair__cell--info\"><div class=\"fairs-fair__info\">" + (jade.escape((jade_interp = ViewHelpers.formatDates(fair)) == null ? '' : jade_interp)) + "</div>");
if ( fair.location && (fair.location.city || fair.location.country))
{
buf.push("<div class=\"fairs-fair__info\">" + (jade.escape(null == (jade_interp = fair.location.city ? fair.location.city : fair.location.country) ? "" : jade_interp)) + "</div>");
}
buf.push("</div></a>");
    }

  }
}).call(this);
}.call(this,"ViewHelpers" in locals_for_with?locals_for_with.ViewHelpers:typeof ViewHelpers!=="undefined"?ViewHelpers:undefined,"pastFairs" in locals_for_with?locals_for_with.pastFairs:typeof pastFairs!=="undefined"?pastFairs:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;